
import { motion } from "framer-motion";
import { CreditCard } from "lucide-react";

interface StickyLoanSummaryProps {
  isSticky: boolean;
  loanAmount: number;
  loanTerm: number;
  monthlyPayment: number;
}

export const StickyLoanSummary = ({ 
  isSticky, 
  loanAmount, 
  loanTerm, 
  monthlyPayment 
}: StickyLoanSummaryProps) => {
  if (!isSticky) return null;
  
  return (
    <motion.div 
      className="fixed top-0 left-0 right-0 z-50 bg-blue-600 text-white py-3 shadow-lg"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="container mx-auto max-w-4xl px-4 flex justify-between items-center">
        <div className="flex items-center">
          <span className="mr-2">Lainasumma: {loanAmount.toLocaleString()} €</span>
          <span className="mx-2">|</span>
          <span className="mr-2">Laina-aika: {loanTerm} vuotta</span>
        </div>
        <div className="flex items-center font-bold">
          <CreditCard className="mr-2 h-5 w-5" />
          <span>Arvioitu kuukausierä: {monthlyPayment.toLocaleString()} €/kk</span>
        </div>
      </div>
    </motion.div>
  );
};
